export function blockInvalidNumberKeys(e, { allowDecimal = false } = {}) {
  const blocked = allowDecimal
    ? ['-', '+', 'e', 'E']
    : ['-', '+', 'e', 'E', '.', ','];
  if (blocked.includes(e.key)) {
    e.preventDefault();
  }
}

export function parseNonNegativeIntInput(raw) {
  if (raw === '') return '';
  if (!/^\d+$/.test(raw)) return null;
  return raw;
}

/** Permite enteros o decimales con `.` o `,` (incluye "12." mientras se escribe). */
export function parseNonNegativeDecimalInput(raw) {
  if (raw === '') return '';
  const normalized = String(raw).replace(',', '.');
  if (!/^\d+\.?\d*$/.test(normalized)) return null;
  return normalized;
}

export function toNonNegativeIntOrNull(raw) {
  const sanitized = parseNonNegativeIntInput(raw);
  if (sanitized === null) return undefined;
  if (sanitized === '') return null;
  return Number(sanitized);
}

/**
 * Para inputs controlados de decimales.
 * - `null` si quedó vacío
 * - string sanitizado (ej. "12." / "12.5") si es válido parcial o completo
 * - `undefined` si el raw no es aceptable (no actualizar el estado)
 */
export function toNonNegativeDecimalOrNull(raw) {
  const sanitized = parseNonNegativeDecimalInput(raw);
  if (sanitized === null) return undefined;
  if (sanitized === '') return null;
  return sanitized;
}
